module.exports = __webpack_public_path__ + "static/media/night03.881b4961.jpeg";